import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/b9/favicon.png'
import bannerRight from '../../assets/image/b9/home/dark-banner-right.png'
import downloadBg from '../../assets/image/b9/home/support-platform/download-bg.png'
import logo from '../../assets/image/b9/logo-dark.svg'
import simpleLogo from '../../assets/image/top-credit/simple-logo.svg'
/** 合规相关 */
import arkham from '../../assets/image/top-credit/legal-compliance/arkham-dark.png'
import blocksec from '../../assets/image/top-credit/legal-compliance/blocksec-dark.png'
import chainanalysis from '../../assets/image/top-credit/legal-compliance/chainalysis-dark.png'
import cloudFlare from '../../assets/image/top-credit/legal-compliance/cloud-flare-dark.png'
import elliptic from '../../assets/image/top-credit/legal-compliance/elliptic-dark.png'
import googleCloud from '../../assets/image/top-credit/legal-compliance/google-cloud-dark.png'
import jamf from '../../assets/image/top-credit/legal-compliance/jamf-dark.png'
import nansen from '../../assets/image/top-credit/legal-compliance/nansen-dark.png'
import slowmist from '../../assets/image/top-credit/legal-compliance/slowmist-dark.png'
import sumsub from '../../assets/image/top-credit/legal-compliance/sumsub-dark.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

const primary = '#FCD535'
const lightPrimary = '#FCD535'
const secondaryPrimary = '#FCD535'
const tertiaryPrimary = '#FCD535'

export const B9DarkConfig: PlatformConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'dark',
  logo: logo,
  logoWidth: 146,
  simpleLogo,
  footerLogo: logo,
  platformName: 'B9',
  loginShowDownload: true,
  colors: {
    hoverPrimary: '#fff',
    lightPrimary: lightPrimary,
    zero: '#424242',
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    link: '#4B5BE7',
    text: {
      base: '#FFFFFF',
      reverse: '#151519',
      primaryAlt: '#D3D4DB',
      secondary: '#A0A3A7',
      tertiary: '#6A6C75',
      quaternary: '#75777A',
      hover: '#FFFFFF',
    },
    bg: {
      base: '#151519',
      reverse: '#ffffff',
      secondary: '#1E1E24',
      hover: '#EAECEF0C',
      tertiary: '#292930',
      icon: {
        primary: '#EAECEF',
        secondary: '#A0A3A7',
        trigger: '#16161A',
        quaternary: '#A0A3A7',
      },
      button: {
        base: primary,
        primary: primary,
        aux: '#23242A',
        disabled: '#A0A0A0',
        primaryTextColor: '#151519',
      },
      tag: {
        base: '#2B2C35',
      },
      form: {
        base: '#1F2023',
        input: '#1F2023',
        modal: '#2C2C2C',
        card: '#23242A',
      },
      mainPage: {
        base: '#16161A',
        card: '#23242A',
        actionBar: '#2B2C35',
      },
      modal: {
        base: '#252525',
        card: '#23242A',
        shadow: 'rgba(0, 0, 0, 0.10)',
      },
    },
    tip: '#2C2C2C',
    cardBorder: '#4B4D5E',
    divider: '#26272D',
    borderSelected: '#A0A3A7',
    sliderMenu: '#2C2C2C',
  },
  ico,
  header: {
    boxShadow: 'none',
    background: '#16161A',
    color: '#fff',
    // boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    aColor: '#fff',
    regBtnBgColor: '#FFFF38', // 注册按钮背景
    regTextColor: '#10151F', // 注册按钮文字颜色
    downloadTextColor: '#fff',
    activeColor: '#fff',
  },
  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },
  compliance: {
    cooperativeInstitutions: {
      list: [
        { logo: chainanalysis, width: 170 },
        { logo: slowmist, width: 154 },
        { logo: nansen, width: 140 },
        { logo: elliptic, width: 130 },
        { logo: jamf, width: 94 },
        { logo: cloudFlare, width: 178 },
        { logo: arkham, width: 140 },
        { logo: sumsub, width: 150 },
        { logo: googleCloud, width: 165 },
        { logo: blocksec, width: 160 },
      ],
    },
  },
} as BaseConfigSource as PlatformConfig)
